var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisabledTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0026 1.83594C5.96094 1.83594 1.83594 5.96094 1.83594 11.0026C1.83594 16.0443 5.96094 20.1693 11.0026 20.1693C16.0443 20.1693 20.1693 16.0443 20.1693 11.0026C20.1693 5.96094 16.0443 1.83594 11.0026 1.83594ZM11.0026 18.3359C6.9601 18.3359 3.66927 15.0451 3.66927 11.0026C3.66927 6.9601 6.9601 3.66927 11.0026 3.66927C15.0451 3.66927 18.3359 6.9601 18.3359 11.0026C18.3359 15.0451 15.0451 18.3359 11.0026 18.3359ZM15.2101 6.95094L9.16927 12.9918L6.7951 10.6268L5.5026 11.9193L9.16927 15.5859L16.5026 8.2526L15.2101 6.95094Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledTick);
export default __webpack_public_path__ + "static/media/DisabledTick.8d910bf9ca654dd3366b705a0c5d622e.svg";
export { ForwardRef as ReactComponent };